<template>
  <div class="button_content">
    <el-button :disabled="!isAllowedClick" @click="submit(true)" class="alone_button">{{text}}</el-button>
    <el-button @click="submit(false)" class="esc_button">{{esctext}}</el-button>
  </div>
</template>

<script>
export default {
  name: "alone-button",
  props: {
    isAllowedClick:{
      type:Boolean,
      required:false,
      default:true,
    },
    text: {
      type: String,
      default: "确定"
    },
    esctext: {
      type: String,
      default: "取消"
    }
  },
  methods: {
    submit(arg) {
      this.$emit('clickbtn', arg)
    }
  }
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.button_content {
  width: 100%;
  margin: 20px 0;
  height : 100%;
  text-align: center;

  .alone_button {
    background: #00abad;
    width: 220px;
    text-align: center;
    color: #fff !important;
    border-color: transparent;
  }

  .esc_button {
    background: #aaadb3 !important;
    width: 220px;
    text-align: center;
    border-color: transparent;
    color: #fff !important;
    margin-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// buttons.vue?3904910f